function removeProjectFromPrice(price: Record<string, any>) {
  const cleanedPrice = price;
  delete cleanedPrice.project;
  return cleanedPrice;
}

function wrapPriceInPutOperation(priceString: string) {
  const price = JSON.parse(priceString);
  const priceUpdate = { op: 'put', item: removeProjectFromPrice(price) };
  return JSON.stringify(priceUpdate, null, 0);
}

export default function convertNDPricesToNDPriceUpdates(ndPrices: string) {
  return ndPrices
    .split('\n')
    .filter(Boolean)
    .map(wrapPriceInPutOperation)
    .join('\n');
}
